import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import AllBlogsNew from "./AllBlogsNew";
import BlogsDetailNew from "./BlogDetailNew";

const BlogTabsNew = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [selectedTab, setSelectedTab] = useState(
    parseInt(params.get("tab") ? params.get("tab") : 0)
  );

  useEffect(() => {
    navigate({
      search: `?tab=${selectedTab}`,
    });
  }, [selectedTab]);
  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <div className="row">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li
                    class="breadcrumb-item cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    Home
                  </li>
                  <li
                    class="breadcrumb-item active fw-bold"
                    aria-current="page"
                  >
                    Blogs
                  </li>
                </ol>
              </nav>
              <h4 className="blognew_header d-flex align-items-center justify-content-between">
                Blogs
                <span>
                  <Link
                    to="/addblog"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Add New"
                    className="btn btn-primary btn-custom me-2"
                  >
                    Add New
                  </Link>

                  {/* <Link
                    to="/blogsdetail"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="View All"
                    className="btn btn-primary btn-custom"
                  >
                    View All
                  </Link> */}
                </span>
              </h4>
            </div>

            <Tabs
              selectedIndex={selectedTab}
              onSelect={(index) => setSelectedTab(index)}
            >
              <TabList>
                <Tab>All posts</Tab>
                <Tab>Scheduled posts</Tab>
              </TabList>

              <TabPanel>
                <div className="container">
                  <div className="row">
                    <BlogsDetailNew />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <h2>
                  <AllBlogsNew />
                  {/* <AddBlog onSubmitBlog={() => setSelectedTab(0)} /> */}
                </h2>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogTabsNew;
